import React, { useContext } from "react";
import { FormContext } from "../context/FormContext";

const StepIndicator = ({ step }) => {
  const { formData } = useContext(FormContext);
  
  // Definir el texto condicional de los labels
  const getStepLabel = (stepNumber) => {
    if (formData?.cadena === "eco") {
      switch (stepNumber) {
        case 1:
          return "Selecciona la tienda";
        case 2:
          return "Elige fecha y hora";
        case 3:
          return "Agrega tus datos";
        default:
          return "";
      }
    } else if (formData?.cadena === "opv") {
      switch (stepNumber) {
        case 1:
          return "Encuentre su tienda";
        case 2:
          return "Programe su examen";
        case 3:
          return "Datos personales";
        default:
          return "";
      }
    }else if (formData?.cadena === "gmo") {
      switch (stepNumber) {
        case 1:
          return "Información de la tienda";
        case 2:
          return "Programar exámenes";
        case 3:
          return "Información de contacto";
        default:
          return "";
      }
    }  else {
      return "Información de la tienda";
    }
  };

  const steps = [
    { number: 1, label: getStepLabel(1) },
    { number: 2, label: getStepLabel(2) },
    { number: 3, label: getStepLabel(3) },
  ];

  return (
    <div 
      className={`row
        ${formData?.cadena === "eco" ? "header-eco" : ""}
        ${formData?.cadena === "gmo" ? "header-gmo" : ""}
      `}
      id="booking-header"
    >
      <div className="container mb0">
        <div className="row">
          <div className="col-xl-12 col">
            <div className="row align-items-center row-cols-5">
              {steps.map((s, index) => (
                <React.Fragment key={s.number}>
                  {/* Paso */}
                  <div className="col pads0">
                    <div>
                      <p
                        className={`header-step ${
                          step === s.number
                            ? "header-step-inprogress"
                            : step > s.number
                            ? "header-step-completed"
                            : "header-step-remaining"
                        }`}
                        id={`head-step-${s.number}`}
                      >
                        <span
                          className={`${
                            step > s.number
                              ? "number-completed"
                              : step === s.number
                              ? "number-inprogress"
                              : "number-remaining"
                          }`}
                        >
                          {step > s.number ? (
                            <span className="fa-stack">
                              <i className="fa fa-circle fa-stack-2x"></i>
                              <i className="fa fa-check fa-stack-1x fa-inverse"></i>
                            </span>
                          ) : (
                            s.number
                          )}
                        </span>{" "}
                        {s.label}
                      </p>
                    </div>
                  </div>

                  {/* Barra de progreso (solo entre pasos, no después del último) */}
                  {index < steps.length - 1 && (
                    <div className="col">
                      <div
                        className={`progress-bar ${
                          step > s.number ? "progress-100" : "progress-align"
                        }`}
                      ></div>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepIndicator;
